import React, { useMemo } from 'react';
import { useTable } from 'react-table';
import './styles/Results.scss';
import {GoogleMap, useLoadScript, Marker} from '@react-google-maps/api';

const API_KEY =  process.env.REACT_APP_GMAP_API_KEY

const MapApp = ({results,userLat,userLng}) => {
    const {isLoaded, loadError} = useLoadScript({
      googleMapsApiKey: API_KEY,
      libraries:['places'],
    });

    const mapContainerStyle = {
      width: '90vw',
      height: '40vh',
    };
    const center ={
      lat: userLat || 48.8566, // Paris latitude
      lng: userLng || 2.3522  // Paris longitude
    };

    if (loadError) return "Error loading maps";
    if (!isLoaded) return "Loading Maps";
    if (!results) return null;
    if (results.length === 0) return <div>No results found</div>;

    return(
      <div className="map-container">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={10}>
      <Marker position={{lat: userLat, lng: userLng}} />

      {results.map((result, index) => (
        <Marker
          key={index}
          position={{ lat: parseFloat(result.lat), lng: parseFloat(result.lng) }}
          title={result['Adresse'] || 'Location'}
        />
      ))}
      </GoogleMap>
      </div>
    );
    };



const Results = (props) => {
  const { results, userLat, userLng } = props;

  const columns = useMemo(() => {
    return [
      {
        Header: 'Nom',
        accessor: 'title'
      },
      {
        Header: 'Adresse',
        accessor: 'Adresse'
      },
      {
        Header: 'Map',
        accessor: 'link'
      },
    ]
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    rows,
    prepareRow,
    headerGroups
  } = useTable({ columns, data: results || [] });

  

    


  if (!results) return null;

  if (results && results.length === 0) {
    return (
      <div>No result found</div>
    );
  }

  return (
    <div className="results">
        <MapApp results={results} userLat={userLat} userLng={userLng}/>
      <table className='Tab' {...getTableProps()}>
        <tbody {...getTableBodyProps()}>
          {
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    const columnId = cell.column.id;
                    const cellValue = cell.value;

                    // Lien
                    if (columnId === 'link' && typeof cellValue === 'string') {
                      return (
                        <td {...cell.getCellProps()}>
                          <a href={cellValue} target="_blank" rel="noopener noreferrer">
                            Lien
                          </a>
                        </td>
                      );
                    }

                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                  })}
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  )
};

export default Results;